<template>
  <div class="container">
    <!-- 서브상단영역 -->
    <Banner
      :title="$route.path.includes(USER_ROUTES.MYPAGEMODIFY) ? 'etc' : ''"
      :subtitle="$route.path.includes(USER_ROUTES.MYPAGEMODIFY) ? 'etc' : ''"
      description="학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>
        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    />
    <div class="width_wrap">
      <MyPageSidebar />
      <div class="body_content sub">
        <h1 class="sub_subject">회원정보수정<span></span></h1>

        <!-- 기관 정보 (기관 사용자에게만 표시) - 사용자 정보 레이아웃과 유사하게 변경 -->
        <div v-if="isOrgUser">
          <h4 class="glores-B-join-form-title glores-B-mgt-none">기관 정보</h4>
          <div class="glores-B-join-wrap glores-B-lan-kr">
            <div class="glores-B-join-form glores-B-lan-kr">
              <dl>
                <dt>기관명</dt>
                <dd>
                  <div class="glores-B-value">{{ formData.org.name }}</div>
                </dd>
              </dl>
              <dl>
                <dt>기관 이메일</dt>
                <dd>
                  <div class="glores-B-value">{{ formData.org.email }}</div>
                </dd>
              </dl>
              <dl>
                <dt>기관 전화번호</dt>
                <dd>
                  <div class="glores-B-value">
                    {{ formData.org.phoneNumber }}
                  </div>
                </dd>
              </dl>
              <dl>
                <dt>기관 설명</dt>
                <dd>
                  <div class="glores-B-value">
                    {{ formData.org.description }}
                  </div>
                </dd>
              </dl>
            </div>
          </div>
        </div>
        <h4 class="glores-B-join-form-title">사용자 정보</h4>
        <div class="glores-B-join-wrap glores-B-lan-kr">
          <form
            name="mem_reg_form"
            method="post"
            action=""
            target="ok_frame"
            enctype="multipart/form-data"
          >
            <div class="glores-B-join-form glores-B-lan-kr">
              <dl>
                <dt><label for="id">아이디</label></dt>
                <dd>
                  <div class="glores-B-value">{{ formData.id }}</div>
                </dd>
              </dl>
              <dl v-if="!isOrgUser">
                <dt><label for="name">이름</label></dt>
                <dd>
                  <input
                    type="text"
                    name="formData.name"
                    id="formData.name"
                    v-model="formData.name"
                    :disabled="formData.disabled"
                  />
                </dd>
              </dl>
              <!-- 기관 관리자 메시지 -->
              <div
                v-if="isOrgAdmin"
                class="admin-info-message"
                style="
                  padding: 20px;
                  text-align: center;
                  background-color: #f0f0f0;
                  border-radius: 4px;
                  margin-top: 20px;
                  margin-bottom: 15px;
                "
              >
                기관 관리자 정보는 수정할 수 없습니다.
              </div>

              <!-- 일반 사용자 또는 기관 일반 사용자 입력 필드 -->
              <dl v-if="isOrgUser && !isOrgAdmin">
                <dt><label for="name">성명</label></dt>
                <dd>
                  <div class="glores-B-value">
                    <div class="reg_name">
                      <input
                        type="text"
                        name="name"
                        id="name"
                        size="20"
                        maxlength="20"
                        v-model="formData.name"
                      />
                    </div>
                  </div>
                </dd>
              </dl>
              <dl v-if="!isOrgAdmin || (isOrgUser && !isOrgAdmin)">
                <dt><label for="email">이메일</label></dt>
                <dd>
                  <div class="glores-B-value">
                    <div class="reg_email">
                      <input
                        type="text"
                        name="email"
                        id="email"
                        v-model="formData.email"
                        :disabled="formData.disabled"
                      />
                    </div>
                  </div>
                  <div class="glores-B-info">이메일 주소를 입력하세요.</div>
                </dd>
              </dl>
              <dl v-if="isOrgUser && !isOrgAdmin">
                <dt><label for="hp1">휴대전화</label></dt>
                <dd>
                  <div class="glores-B-value">
                    <div class="reg_mobileNumber">
                      <input
                        type="text"
                        name="hp1"
                        size="4"
                        maxlength="4"
                        v-model="formData.hp1"
                        title="휴대전화 첫번째"
                      />
                      -
                      <input
                        type="text"
                        name="hp2"
                        size="4"
                        maxlength="4"
                        v-model="formData.hp2"
                        title="휴대전화 두번째"
                      />
                      -
                      <input
                        type="text"
                        name="hp3"
                        size="4"
                        maxlength="4"
                        v-model="formData.hp3"
                        title="휴대전화 세번째"
                      />
                    </div>
                  </div>
                </dd>
              </dl>
              <!-- 기관 사용자 전용 필드 (기관 일반 사용자만 수정 가능) -->
              <dl v-if="isOrgUser && !isOrgAdmin">
                <dt><label for="role">역할</label></dt>
                <dd>
                  <div class="glores-B-value">
                    <input
                      type="text"
                      name="role"
                      id="role"
                      size="30"
                      v-model="formData.role"
                    />
                  </div>
                </dd>
              </dl>
              <dl v-if="isOrgUser && !isOrgAdmin">
                <dt><label for="position">직책</label></dt>
                <dd>
                  <div class="glores-B-value">
                    <input
                      type="text"
                      name="position"
                      id="position"
                      size="30"
                      v-model="formData.position"
                    />
                  </div>
                </dd>
              </dl>
              <dl v-if="isOrgUser && !isOrgAdmin">
                <dt><label for="description">기타 (설명)</label></dt>
                <dd>
                  <div class="glores-B-value">
                    <textarea
                      name="description"
                      id="description"
                      rows="5"
                      style="width: 100%"
                      v-model="formData.description"
                    ></textarea>
                  </div>
                </dd>
              </dl>
            </div>
            <div class="glores-B-btn-wrap btn-pc-align-bothside">
              <div class="btn-align-left">
                <n-button
                  type="primary"
                  :bordered="false"
                  @click="updateMemberInfo"
                  :loading="loading"
                  style="min-width: 150px; background-color: #be7b42"
                  :disabled="formData.disabled"
                >
                  수정
                </n-button>
              </div>
              <div class="btn-align-right">
                <div class="glores-B-mem-modify-btns">
                  <div
                    v-if="
                      (!isOrgAdminUser || (isOrgUser && !isOrgAdminUser)) &&
                      !formData.disabled
                    "
                    class="btn-cell"
                  >
                    <n-button
                      type="primary"
                      :bordered="false"
                      @click.prevent="showChangePassword = true"
                      style="min-width: 150px; background-color: #be7b42"
                      :disabled="formData.disabled"
                    >
                      비밀번호변경
                    </n-button>
                  </div>
                  <div v-if="!isOrgUser" class="btn-cell">
                    <n-button
                      type="primary"
                      :bordered="false"
                      @click.prevent="withdrawUser"
                      :loading="withdrawLoading"
                      style="min-width: 150px; background-color: #be7b42"
                    >
                      회원탈퇴
                    </n-button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <n-modal
      v-model:show="showChangePassword"
      preset="card"
      style="width: 600px"
      title="비밀번호 변경"
      @after-leave="onChangePasswordModalClose"
    >
      <div id="glores-B-popup-wrap">
        <div id="glores-B-popup-header">
          <h1>비밀번호 변경</h1>
          <button
            type="button"
            id="glores-B-popup-h-close"
            onclick="popup_window_close()"
          >
            닫기
          </button>
        </div>
        <div
          id="glores-B-popup-contents"
          class="glores-B-pwd-change-wrap"
          style="padding: 17px 16px 20px; position: relative"
        >
          <!-- 모달 로딩 상태 표시 (오버레이 스타일 적용) -->
          <div
            v-if="loading"
            class="modal-loading-overlay"
            style="
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background-color: rgba(255, 255, 255, 0.8);
              display: flex;
              justify-content: center;
              align-items: center;
              z-index: 10; /* content-container 보다 높게 설정 */
            "
          >
            <n-spin size="large" />
          </div>
          <div id="content-container">
            <ul class="glores-B-change-pwd-help">
              <li>
                비밀번호는 연속번호나 전화번호 등 타인이 알기 쉬운 숫자는 되도록
                삼가 주십시오.
              </li>
              <li>
                비밀번호는 8자 이상 영문 + 숫자+ 특수문자를 모두 조합해서
                입력해주세요.
              </li>
              <li>비밀번호는 암호화 되어 보관되므로 안심하셔도 됩니다.</li>
            </ul>

            <div class="glores-B-change-pwd-form-wrap">
              <form name="pwd_ch_form" method="post" style="margin: 0">
                <input type="hidden" name="this_domain" />
                <input type="hidden" name="post_action" />
                <input
                  type="hidden"
                  name="form_sess_id"
                  value="d101j0c86plfiucktc2r8cal21"
                />
                <input type="hidden" name="auth_code" value="" />
                <div class="glores-B-change-pwd-form">
                  <dl>
                    <dt><label for="glores-B-pwd1">기존 비밀번호</label></dt>
                    <dd>
                      <input
                        type="password"
                        id="old_password"
                        class="glores-B-input-text"
                        name="pwd"
                        size="15"
                        v-model="changePasswordForm.old_password"
                        maxlength="15"
                        style="width: 100%"
                      />
                    </dd>
                  </dl>
                  <dl>
                    <dt><label for="glores-B-pwd2">새 비밀번호</label></dt>
                    <dd>
                      <input
                        type="password"
                        id="new_password"
                        class="glores-B-input-text"
                        name="new_pwd"
                        size="15"
                        v-model="changePasswordForm.new_password"
                        maxlength="15"
                        style="width: 100%"
                      />
                    </dd>
                  </dl>
                  <dl>
                    <dt><label for="glores-B-pwd3">새 비밀번호 확인</label></dt>
                    <dd>
                      <input
                        type="password"
                        id="new_password_confirm"
                        class="glores-B-input-text"
                        name="new_pwd2"
                        size="15"
                        v-model="changePasswordForm.new_password_confirm"
                        maxlength="15"
                        style="width: 100%"
                      />
                    </dd>
                  </dl>
                </div>
              </form>
              <div class="glores-B-popup-bt-btns">
                <a
                  @click.prevent="changePassword()"
                  href="#"
                  class="glores-B-popup-bt-btn-type1 glores-B-full-width glores-B-highlight"
                  >비밀번호 변경</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </n-modal>
  </div>
</template>

<script setup lang="ts">
import MyPageSidebar from "@/views/member/MypageSidebar.vue";
import {
  NIcon,
  NButton,
  NSpin,
  useMessage,
  useNotification,
  useDialog,
} from "naive-ui"; // useMessage 임포트
import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useRoute, useRouter } from "vue-router";
import { firebaseAuth, getCallable } from "@/config/env";
import { useAuth } from "@/composables/useAuth";
import * as common from "@/assets/common/common.ts";
import { ref, onMounted, computed } from "vue";
import * as constant from "@/constants/constant";
import { useActionDialog } from "@/composables/useDialog";
const { show: showActionDialog } = useActionDialog();

const message = useMessage();
const notification = useNotification();
const dialog = useDialog();

const {
  isLoggedIn,
  loggedInUserId,
  loggedInUserName,
  handleLogout,
  isOrgUser,
  loading,
  isOrgAdmin,
  loginType,
} = useAuth();
const updateMemberInfoCallable = getCallable("updateMemberInfo");
const withdrawUserCallable = getCallable("withdrawUser");

const changeMemberPasswordCallable = getCallable("changeMemberPassword");
const changeOrgUserPasswordCallable = getCallable("changeOrgUserPassword");

const route = useRoute();
const router = useRouter();
const showChangePassword = ref<boolean>(false);
const withdrawLoading = ref<boolean>(false);
// 폼 데이터를 위한 ref (실제 폼 필드에 맞게 구조 정의 필요)
const formData = ref({
  id: "",
  name: "",
  email: "",
  hp1: "",
  hp2: "",
  hp3: "",
  role: "",
  position: "",
  description: "", // 기관 사용자용 기타 설명
  disabled: false,
  org: {
    description: "",
    email: "",

    name: "",
    phoneNumber: "",
  },
});

const changePasswordForm = ref({
  old_password: "",
  new_password: "",
  new_password_confirm: "",
});
// 사용자 유형 판단
const isOrgAdminUser = computed(() => {
  return isOrgAdmin.value;
});

onMounted(() => {
  loading.value = true; // 로딩 시작
  showChangePassword.value = false;
  const authInfo = common.getLocalAuth();
  if (authInfo) {
    if (loginType.value == "user") {
      if (authInfo.type == constant.loginType.CUSTOM) {
        formData.value.id = authInfo.uid.split(":")[1];
      } else {
        formData.value.disabled = true;
        formData.value.id = authInfo.email!;
      }
    }
    formData.value.name = authInfo.name || "";

    formData.value.email = authInfo.email || "";
    if (authInfo.phoneNumber) {
      let hps: string[] = authInfo.phoneNumber?.split("-");
      if (hps.length == 3) {
        formData.value.hp1 = hps[0];
        formData.value.hp2 = hps[1];
        formData.value.hp3 = hps[2];
      }
    }
    if (isOrgUser.value && authInfo.orgId && authInfo.uid) {
      let org = authInfo.org;
      if (org) {
        formData.value.org = org;
      }
      if (!isOrgAdminUser.value) {
        formData.value.role = authInfo.role || "";
        formData.value.position = authInfo.position || "";
        formData.value.description = authInfo.description || "";
      }
    }
  } else {
    console.log("로그인된 사용자 정보가 없습니다.");
  }
  loading.value = false; // 로딩 종료
});

function onChangePasswordModalClose() {
  showChangePassword.value = false;
  changePasswordForm.value = {
    old_password: "",
    new_password: "",
    new_password_confirm: "",
  };
}
const validatePassword = () => {
  let isValid = true;
  // 패스워드 유효성 검사 (8~16자, 영문, 숫자, 특수문자 조합)
  const passwordRegex =
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,16}$/;
  if (!changePasswordForm.value.new_password) {
    isValid = false;
  } else if (!passwordRegex.test(changePasswordForm.value.new_password)) {
    notification.error({
      title: "에러",
      description:
        "패스워드는 8~16자의 영문, 숫자, 특수문자를 모두 포함해야 합니다.",
      duration: 1500,
      closable: true,
    });
    isValid = false;
  }
  return isValid;
};
async function changePassword() {
  if (
    changePasswordForm.value.new_password !==
    changePasswordForm.value.new_password_confirm
  ) {
    notification.error({
      title: "에러",
      description: `새 비밀번호와 새 비밀번호 확인이 일치하지 않습니다.`,
      duration: 1500,
      closable: true,
    });
    return;
  }
  // TODO : 비밀번호 정책 정해진 후 아래 주석 해제 및 보완
  if (!validatePassword()) {
    return;
  }
  // TODO: 새 비밀번호에 대한 추가 유효성 검사 (영문, 숫자, 특수문자 조합 등)

  loading.value = true;
  try {
    let result: any;
    const payload = {
      old_password: changePasswordForm.value.old_password,
      new_password: changePasswordForm.value.new_password,
      uid: common.getLocalAuth().uid,
      type: common.getLocalAuth().type,
    };
    if (isOrgUser.value && !isOrgAdminUser.value) {
      const orgUserPayload = {
        ...payload,
        orgId: common.getLocalAuth().orgId,
      };
      result = await changeOrgUserPasswordCallable(orgUserPayload);
    } else if (!isOrgUser.value) {
      // 일반 사용자
      const memberPayload = {
        ...payload,
      };
      result = await changeMemberPasswordCallable(memberPayload);
    } else {
      notification.error({
        title: "에러",
        description: `비밀번호를 변경할 수 없는 사용자 유형입니다.`,
        duration: 1500,
        closable: true,
        onAfterLeave: () => {
          showChangePassword.value = false; // 모달 닫기
        },
      });
      loading.value = false;
      return;
    }
    if (common.evalFunctionResult(result)) {
      notification.success({
        title: "성공",
        description: "비밀번호가 성공적으로 변경되었습니다.",
        duration: 3000,
        closable: true,
        onAfterLeave: () => {
          showChangePassword.value = false; // 모달 닫기
        },
      });
      changePasswordForm.value = {
        old_password: "",
        new_password: "",
        new_password_confirm: "",
      }; // 폼 초기화
    } else {
      console.error("비밀번호 변경 중 오류:", common.getResultError(result));
      notification.error({
        title: "에러",
        description: `비밀번호 변경 실패: ${
          common.getResultError(result) || "오류가 발생했습니다."
        }`,
        duration: 1500,
        closable: true,
      });
    }
  } catch (error: any) {
    console.error("비밀번호 변경 중 오류:", error);
    notification.error({
      title: "에러",
      description: `비밀번호 변경 중 오류가 발생했습니다: ${
        error.message || "알 수 없는 오류"
      }`,
      duration: 1500,
      closable: true,
    });
  } finally {
    loading.value = false;
  }
}

async function updateMemberInfo() {
  showActionDialog({
    title: "확인",
    content: "회원 정보를 변경 하시겠습니까?",
    positiveText: "네",
    negativeText: "아니요",
    positiveButtonProps: { type: "default" },
    confirmButtonLoadingText: "처리 중...",
    onConfirm: async () => {
      loading.value = true;
      try {
        const currentAuth = common.getLocalAuth();
        const payload = {
          uid: currentAuth.uid,
          type: currentAuth.type,
          email: formData.value.email,
        } as any;
        if (!isOrgUser.value && !isOrgAdminUser.value) {
          payload.name = formData.value.name;
        }
        const result = await updateMemberInfoCallable(payload);
        if (common.evalFunctionResult(result)) {
          currentAuth.email = formData.value.email; // 변경된 이메일로 업데이트
          if (!isOrgUser.value && !isOrgAdminUser.value) {
            currentAuth.name = formData.value.name;
          }
          common.setLocalAuth(currentAuth);
          notification.success({
            title: "성공",
            description: "정보 변경 성공",
            duration: 1000,
            closable: true,
          });
        } else {
          notification.error({
            title: "에러",
            description: `정보 변경 실패: ${
              common.getResultError(result) || "오류가 발생했습니다."
            }`,
            duration: 1500,
            closable: true,
          });
        }
      } catch (error: any) {
        notification.error({
          title: "에러",
          description: `정보 변경 실패: ${error.message || "알 수 없는 오류"}`,
          duration: 1500,
          closable: true,
        });
      } finally {
        loading.value = false;
      }
    },
    onCancel: () => {
      console.log("canceled update memeber info");
    },
  });
}

async function withdrawUser() {
  showActionDialog({
    title: "확인",
    content: "탈퇴 하시겠습니까?",
    positiveText: "네",
    negativeText: "아니요",
    positiveButtonProps: { type: "error" },
    confirmButtonLoadingText: "처리 중...",
    onConfirm: async () => {
      withdrawLoading.value = true;
      try {
        const currentAuth = common.getLocalAuth();
        const payload = {
          uid: currentAuth.uid,
        } as any;

        const result = await withdrawUserCallable(payload);
        if (common.evalFunctionResult(result)) {
          common.removeLocalAuth();
          notification.success({
            title: "성공",
            description: "회원 탈퇴 성공",
            duration: 1000,
            closable: true,
          });
          router.push(USER_ROUTES.Home.Path);
        } else {
          notification.error({
            title: "에러",
            description: `회원 탈퇴 실패: ${
              common.getResultError(result) || "오류가 발생했습니다."
            }`,
            duration: 1500,
            closable: true,
          });
        }
      } catch (error: any) {
        notification.error({
          title: "에러",
          description: `회원 탈퇴 실패: ${error.message || "알 수 없는 오류"}`,
          duration: 1500,
          closable: true,
        });
      } finally {
        withdrawLoading.value = false;
      }
    },
    onCancel: () => {
      console.log("canceled withDraw");
    },
  });
}
</script>

<style scoped>
.sub_title_01 p {
  position: absolute;
  top: 70px;
  left: 0;
  margin-top: -15px;

  width: 100%;
  font-size: 30px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 600;
}
.sub_title_01 h2 {
  position: absolute;
  top: 130px;
  left: 0;
  margin-top: -15px;

  width: 100%;
  font-size: 19px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 500;
  line-height: 1.7em;
}

.sub_scroll_wrap {
  overflow: hidden;
  height: 39px;
  border-bottom: 1px solid #ccc;
  background: #fff;
}
.sub_scroll_wrap > div {
  position: relative; /*padding: 0 30px;*/
}
.sub_scroll_wrap > div > div {
  overflow-x: scroll;
}
.sub_scroll_wrap > div > div .scroll_nav {
  display: inline-block;
  min-width: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  list-style: none;
  font-size: 0;
  text-align: center;
  white-space: nowrap;
}
.sub_scroll_wrap > div > div .scroll_nav li {
  display: inline-block;
}
.sub_scroll_wrap > div > div .scroll_nav li a {
  display: inline-block;
  height: 39px;
  line-height: 39px;
  padding: 0 12px;
  font-size: 13px;
  color: #bbb;
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
  box-sizing: border-box;
  font-weight: 600;
}
.sub_scroll_wrap > div > div .scroll_nav li.on a {
  color: #be7b42;
  font-weight: 600;
}
.sub_scroll_wrap > div i {
  position: absolute;
  left: 0;
  top: 0;
  width: 30px;
  height: 39px;
}
.sub_scroll_wrap > div i.prev:before {
  content: "";
  position: absolute;
  top: 0;
  left: 3px;
  bottom: 0;
  width: 0;
  height: 0;
  margin: auto;
  border: 6px solid transparent;
  border-right-color: #333;
}
.sub_scroll_wrap > div i.next {
  right: 0;
  left: inherit;
}
.sub_scroll_wrap > div i.next:before {
  content: "";
  position: absolute;
  top: 0;
  right: 3px;
  bottom: 0;
  width: 0;
  height: 0;
  margin: auto;
  border: 6px solid transparent;
  border-left-color: #333;
}
@media screen and (min-width: 768px) {
  .sub_scroll_wrap > div i {
    display: none;
  }
}
@media screen and (min-width: 1200px) {
  .sub_scroll_wrap {
    overflow: visible;
    height: auto;
    border-bottom: none;
    background: #fff;
    box-shadow: 3px 3px 3px rgb(0 0 0 / 10%);
  }
  .sub_scroll_wrap > div {
    position: relative;
    padding: 0;
  }
  .sub_scroll_wrap > div > div {
    overflow: hidden;
  }
  .sub_scroll_wrap > div > div .scroll_nav {
    display: table;
    margin: 0;
    width: 100%;
    padding: 0;
    white-space: normal;
    text-align: left;
    border-collapse: collapse;
  }
  .sub_scroll_wrap > div > div .scroll_nav li {
    display: table-cell;
    width: 33%;
    position: relative;
  }
  .sub_scroll_wrap > div > div .scroll_nav li:after {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    right: 0;
    background: #bbb;
    width: 1px;
    height: 15px;
    margin-top: -7px;
  }
  .sub_scroll_wrap > div > div .scroll_nav li:last-child:after {
    display: none;
  }
  .sub_scroll_wrap > div > div .scroll_nav li:before {
    position: absolute;
    visibility: hidden;
    left: 0;
    bottom: 0px;
    right: 0px;
    width: 100%;
    height: 3px;
    background: #be7b42;
    content: "";
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transition: all 0.2s ease-in-out 0s;
    transition: all 0.2s ease-in-out 0s;
    opacity: 0.85;
  }
  .sub_scroll_wrap > div > div .scroll_nav li a {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    height: 60px;
    line-height: 60px;
    padding: 0 5px;
    font-size: 16px;
    text-align: center;
    color: #bbbbbb;
    font-weight: 600;
  }
  .sub_scroll_wrap > div > div .scroll_nav li a:hover {
    color: #be7b42;
  }
  .sub_scroll_wrap > div > div .scroll_nav li.on a {
    color: #be7b42;
  }
  .sub_scroll_wrap > div > div .scroll_nav li.on:before,
  .sub_scroll_wrap > div > div .scroll_nav li:hover:before {
    visibility: visible;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }
}

.sub04_wrap * {
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
  box-sizing: border-box;
  word-break: keep-all;
}
.sub04_wrap > ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.sub04_wrap > ul li {
  width: 48%;
}
.sub04_wrap > ul li figure {
  border: 1px solid #ddd;
}
.sub04_wrap > ul li:nth-child(-n + 2) {
  margin-bottom: 30px;
}
.sub04_wrap > ul li a {
  display: block;
  border-radius: 10px;
  position: relative;
  transition: all.2s;
}
.sub04_wrap > ul li h1 {
  font-size: 14px;
  font-weight: 500;
  padding-top: 15px;
  text-align: center;
}
.sub04_wrap > ul li a > div.bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: none;
  opacity: 0;
  transition: all.2s;
}
.sub04_wrap > ul li a > div.bg > span {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  line-height: 80px;
  text-align: center;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 50%;
  background: #ba7b3d;
  color: #fff;
  font-weight: 500;
}
@media screen and (min-width: 768px) {
  .sub04_wrap > ul {
    justify-content: normal;
  }
  .sub04_wrap > ul li h1 {
    font-size: 16px;
  }
  .sub04_wrap > ul li {
    width: 23.5%;
    margin-right: 2%;
  }
  .sub04_wrap > ul li:nth-child(-n + 2) {
    margin-bottom: 0px;
  }
  .sub04_wrap > ul li:last-child {
    margin-right: 0;
  }
  .sub04_wrap > ul li a:hover > div.bg {
    display: block;
    opacity: 1;
  }
}
</style>
